export default {"src":"/_next/static/media/abalone.60e20612.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};